import { useNavigate } from "react-router-dom";
import React, { useState, useRef, useEffect } from "react";
import { clearAuth, getSellerNotifications, syncRoleEntityIdsFromServer } from "../../utils/api";
import { getAvailableRoles, getRole, setRole } from "../../auth/roleService";

const Header = ({ searchTerm, onSearchChange, onMobileMenuToggle }) => {
  const navigate = useNavigate();

  const [openMenu, setOpenMenu] = useState(false);
  const [openNotifications, setOpenNotifications] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [loadingNotifications, setLoadingNotifications] = useState(false);

  // const roles = ["seller", "buyer", "freight"];
  const roles = getAvailableRoles()?.split(',');

  const [currentRole, setCurrentRole] = useState(getRole() || "seller");
  const [openRoleDropdown, setOpenRoleDropdown] = useState(false);

  const menuRef = useRef(null);

  const handleRoleSwitch = async (role) => {
    setCurrentRole(role);
    setRole(role);
    setOpenRoleDropdown(false);

    await syncRoleEntityIdsFromServer();

    window.location.href = "/dashboard";
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpenMenu(false);
        setOpenNotifications(false);
        setOpenRoleDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (openNotifications) {
      fetchNotifications();
    }
  }, [openNotifications]);

  const fetchNotifications = async () => {
    try {
      setLoadingNotifications(true);
      const res = await getSellerNotifications();

      const list = Array.isArray(res.data) ? res.data : [res.data];
      setNotifications(list);

    } catch (err) {
      console.error("Notification fetch failed", err);
    } finally {
      setLoadingNotifications(false);
    }
  };

  const handleLogout = () => {
    clearAuth();
    window.location.href = "/login";
  };

  return (
    <header className="dashboard-header">

      <div className="header-left">
        <button
          className="mobile-menu-toggle"
          onClick={onMobileMenuToggle}
        >
          <i className="fas fa-bars"></i>
        </button>
      </div>

      <div className="header-center">
        <div className="search-bar">
          <i className="fas fa-search"></i>
          <input
            type="text"
            placeholder="Search related any grade, bid, offers etc..."
            className="search-input"
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
          />
        </div>
      </div>

      <div className="header-right" ref={menuRef}>

        {/* Notifications */}
        <button
          className="header-icon-btn"
          aria-label="Notifications"
          onClick={() => {
            setOpenNotifications(!openNotifications);
            setOpenMenu(false);
          }}
        >
          <i className="fas fa-bell"></i>
        </button>

        {openNotifications && (
          <div className="notification-popup">

            <div className="notification-header">
              Notifications
            </div>

            <div className="notification-body">

              {loadingNotifications && (
                <div className="notification-loading">
                  Loading...
                </div>
              )}

              {!loadingNotifications && notifications.length === 0 && (
                <div className="notification-empty">
                  No notifications
                </div>
              )}

              {!loadingNotifications &&
                notifications.map((n) => (
                  <div className="notification-item" key={n.id}>
                    <div className="notification-title">
                      {n.title}
                    </div>

                    <div className="notification-desc">
                      {n.description}
                    </div>

                    <div className="notification-time">
                      {new Date(n.created_at).toLocaleString()}
                    </div>
                  </div>
                ))}
            </div>
          </div>
        )}

        {/* Avatar */}
        <div
          className="user-avatar"
          onClick={() => {
            setOpenMenu(!openMenu);
            setOpenNotifications(false);
          }}
        >
          <span>OP</span>
        </div>

        {openMenu && (
          <div className="user-menu">

            {/* Role Switcher */}
            <div className="user-menu-item role-switcher">

              <div
                className="role-current"
                onClick={() => setOpenRoleDropdown(!openRoleDropdown)}
              >
                <i className="fas fa-user-tag"></i>
                {currentRole}
                <i className="fas fa-chevron-down role-arrow"></i>
              </div>

              {openRoleDropdown && (
                <div className="role-dropdown">

                  {roles.map((role) => (
                    <div
                      key={role}
                      className={`role-option ${role === currentRole ? "active-role" : ""
                        }`}
                      onClick={() => handleRoleSwitch(role)}
                    >
                      {role}
                    </div>
                  ))}

                </div>
              )}

            </div>

            {/* Logout */}
            <button
              className="user-menu-item logout"
              onClick={handleLogout}
            >
              <i className="fas fa-sign-out-alt"></i>
              Logout
            </button>

          </div>
        )}

      </div>
    </header>
  );
};

export default Header;